import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { first } from "rxjs/operators";
import { AuthenticationService } from "src/app/_services";
import { ApiService } from "src/app/api.service";
import { CookieTovpil } from "src/app/shared/models/CookieTovpil";
import { GuideModel } from "src/app/shared/models/guide-model";
import { Item } from "src/app/shared/models/Item";
import { PurchItmDwnAppHVO } from "src/app/shared/models/PurchItmDwnAppHVO";
import { PurchItmDwnAppVO } from "src/app/shared/models/PurchItmDwnAppVO";
import { TovpilCrudService } from "src/app/utils/tovpil-crud-service";
import { TovpilFilesService } from "src/app/utils/tovpil-files.service";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";
import { UserPreferencesService } from "src/app/utils/user-preferences.service";

@Component({
  selector: "app-confirm-audio-reprod",
  templateUrl: "./confirm-audio-reprod.component.html",
  styleUrls: ["./confirm-audio-reprod.component.scss"],
  providers: [MessageService, ConfirmationService, TovpilLanguageService],
})
export class ConfirmAudioReprodComponent implements OnInit {
  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** PIPES */
  datePipe: DatePipe = new DatePipe("en-US");

  /** LABELS */
  translations: Record<string, string> = {};

  /** DIALOG */
  displayModal: boolean = false;

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** COMPONENT */
  audioStatus;
  docId;
  sequence;

  // Tabla Future Guides
  futureGuidesCols = [
    { field: "itemName", header: "lbl_item" },
    // { field: "guideType", header: "lbl_type" },
    { field: "statusName", header: "lbl_status" },
  ];
  futureGuidesFilters = ["statusName", "itemName"];
  futureGuidesList: PurchItmDwnAppVO[];
  language: string;

  // Tabla Items
  itemsList: Item[];
  itemsString: string;

  /**
   * The constructor initializes various services and sets up user preferences based on authentication
   * and security settings.
   * @param {MessageService} messageService - The `messageService` parameter is likely a service used
   * for displaying messages or notifications to the user in the application. It could be responsible
   * for handling communication of messages between different components or services within the
   * application.
   * @param {ApiService} apiService - The `apiService` parameter in the constructor is likely a service
   * that handles API requests and responses in your application. It is used to communicate with
   * backend servers, fetch data, send data, and perform other operations related to interacting with
   * APIs.
   * @param {ActivatedRoute} route - The `route` parameter in the constructor is of type
   * `ActivatedRoute` which is a service provided by Angular that gives you access to information about
   * a route associated with a component that is loaded in an outlet. It allows you to access route
   * parameters, query parameters, and other information related to the current
   * @param {AuthenticationService} authenticationService - The `authenticationService` parameter in
   * the constructor is a service that handles user authentication within the application. It likely
   * provides methods for user login, logout, and authentication status checks. This service is
   * essential for managing user sessions and ensuring that users have the necessary permissions to
   * access certain parts of the application.
   * @param {UrlBuilderService} urlBuilderService - The `urlBuilderService` is a service that helps in
   * building and managing URLs within the application. It is commonly used for constructing URLs for
   * API endpoints, routing within the application, and handling dynamic URL parameters. This service
   * abstracts the complexity of URL construction and provides methods to easily generate URLs based on
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter in the
   * constructor is likely a service that handles CRUD (Create, Read, Update, Delete) operations for
   * data in the application. It is used to interact with the backend API to perform operations such as
   * creating new data, retrieving data, updating existing data
   * @param {FormBuilder} fb - The `fb` parameter in the constructor is an instance of `FormBuilder`
   * from Angular Forms. It is used to create form controls and groups for reactive forms in Angular
   * applications.
   * @param {TovpilUtilsService} tovUtilsService - The `tovUtilsService` parameter in the constructor
   * is likely a service that provides utility functions or helper methods related to the functionality
   * of the application. It could contain methods for common tasks such as data manipulation,
   * validation, formatting, or any other utility functions that are used across different parts of the
   * application
   * @param {UserPreferencesService} userPreferencesService - The `userPreferencesService` parameter in
   * the constructor is a service that is responsible for managing and storing user preferences within
   * the application. It likely provides methods to retrieve, update, and store user-specific settings
   * and configurations, such as language preferences, theme choices, or any other custom settings that
   * users can personalize
   * @param {Router} router - The `router` parameter in the constructor is used for routing in Angular
   * applications. It provides navigation and URL manipulation capabilities in your application. You
   * can use it to navigate to different components or routes within your application.
   * @param {TovpilFilesService} filesService - The `filesService` parameter in the constructor is
   * likely a service that handles file-related operations in the application. This service may be
   * responsible for tasks such as uploading files, downloading files, managing file storage, and
   * handling file-related configurations.
   * @param {TovpilLanguageService} translationService - The `translationService` parameter in the
   * constructor is likely used for handling language translation within the application. It is
   * injected as a dependency to provide translation services such as translating text or messages
   * displayed in the user interface into different languages based on user preferences or settings.
   * This service helps in making the application more user
   */
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private tovpilCrudService: TovpilCrudService,
    private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService
  ) {
    this.createDataForm();
    this.initConfigs();

    this.route.queryParams.subscribe((params) => {
      this.globalUserDataForm.patchValue({
        selectedGuideId: params.guideId ?? null,
        selectedWorkshopId: params.wrksId ?? null,
      });

      this.language = params.language;
      this.itemsString = params.lstItems;
      this.docId = params.docId;
      this.sequence = params.sequence;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
   * The `createDataForm` function in TypeScript creates a reactive form with specific form controls.
   */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedGuide: new FormControl(null),
      selectedWorkshopId: new FormControl(null),
      selectedWorkshop: new FormControl(null),
      selectedGuideId: new FormControl(null),
      selectedGuideType : new FormControl(null)
    });

    // console.debug(
    //   "MatNatReqDtlComponent - REACTIVE FORM: ",
    //   JSON.stringify(this.globalUserDataForm.getRawValue(), null, 2)
    // );
  }

  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  ngOnInit(): void {
    this.getSecurity();
  }

  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE EN CASO DE QUE SEA NULL
    if (securityControl === null || Object.keys(securityControl).length === 0) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences.preferences = data;
    }

    await this.getTranslatedLabels();
    await this.getData();
  }

  async getTranslatedLabels() {
    const language =
      this.globalUserPreferences?.preferences?.language || this.language;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      this.translateCols();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  translateCols() {
    const translateFGdCols = this.futureGuidesCols.map((e) => ({
      ...e,
      header: this.translations[e.header],
    }));
    this.futureGuidesCols = translateFGdCols;
  }

  async getData() {
    await this.getStatus();
    await this.getGuideById();
    await this.getFutureGuides();

    this.blocked = false;
  }

  async getStatus() {
    this.audioStatus = await this.apiService.getCategoryLang({
      language: this.language,
      fieldId: "purAudiSts",
    });
  }

  async getGuideById() {
    const guideId = this.globalUserDataForm.get("selectedGuideId").value;
    const guiTypes = await this.apiService.getCategoryLang({
      'language': this.language,
      'fieldId': "guiType"
    });
    const guide : GuideModel = await this.apiService.getGuideById({
      guideId: guideId,
    });

    const typeGuide = guiTypes.find(e => guide.guiType == e.fieldVal);

    console.debug(typeGuide);
    this.globalUserDataForm.patchValue({
      selectedGuide: guide.name + " " + guide.lastName,
      selectedGuideType : typeGuide.descrip
    });
  }

  async getFutureGuides() {
    const workshopId = this.globalUserDataForm.get("selectedWorkshopId").value;
    const guideId = this.globalUserDataForm.get("selectedGuideId").value;
    const language =
      this.globalUserPreferences?.preferences?.language || this.language;
    const items = this.itemsString.split(",");

    try {
      const futureGuides: PurchItmDwnAppHVO =
        await this.apiService.getItemsToApproveFromOrder({
          guideId: guideId,
          wrksId: workshopId,
          language: language,
          lstValues: items,
        });

      let approved = this.audioStatus.find((e) => {
        return e.fieldVal == "A";
      });
      let needApproval = this.audioStatus.find((e) => {
        return e.fieldVal == "N";
      });

      this.futureGuidesList = futureGuides.lstPurchItm.map((e) => ({
        ...e,
        autorized: true,
        storedStatus:
          e.purchItmDwn.status == "A"
            ? approved.descrip
            : needApproval.descrip,
        storedIdStatus: e.purchItmDwn.status == "A" ? "A" : "N",
        statusName : e.purchItmDwn.status == "A" ? approved.descrip : needApproval.descrip,
        purchItmDwn: {
          ...e.purchItmDwn,
          status: e.purchItmDwn.status == "A" ? "A" : "N",
        },
      }));

      // console.debug(this.futureGuidesList);
      this.globalUserDataForm.patchValue({
        selectedCoordination: futureGuides.storeName ?? "",
        selectedWorkshop: futureGuides.serviceName ?? "",
      });

      this.itemsList = futureGuides.lstItm;
    } catch (error) {
      this.messageService.add({
        severity: "error",
        summary: `${this.translations.lbl_error} ${this.translations.lbl_params}`,
        detail: `${this.translations.lbl_there_is_not} ${this.translations.lbl_information} ${this.translations.lbl_to} ${this.translations.lbl_show}`,
        life: 3000,
      });
      console.error("Error en futureguides:", error);
    }
  }

  continue() {
    this.confirmationService.confirm({
      message: "¿" + this.translations.lbl_wish_to_continue + "?",
      header: this.translations.lbl_confirm,
      icon: "pi pi-exclamation-triangle",
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      accept: async () => {
        await this.updateItems();
        await this.approveItems();
      },
    });
  }

  handleChange(e, guide: any) {
    let isChecked = e.checked;
    let blocked = this.audioStatus.find((e) => {
      return e.fieldVal == "B";
    });
    if (isChecked) {
      guide.purchItmDwn.status = guide.storedIdStatus;
      guide.statusName = guide.storedStatus;
    } else {
      guide.purchItmDwn.status = "B";
      guide.statusName = blocked.descrip;
    }
  }

  getFieldValue(row: any, field: string): any {
    return field.split(".").reduce((acc, key) => acc && acc[key], row);
  }

  getLastField(guide: any, field: string) {
    if (field.split(".").length == 1) {
      return guide[field];
    } else if (field.split(".").length > 1) {
      return field.split(".").reduce((acc, key) => {
        return acc && acc[key] !== null ? acc[key] : null;
      }, guide);
    }
  }

  async updateItems() {
    this.blocked = true;
    if (this.futureGuidesList !== null && this.futureGuidesList !== undefined) {
      if (this.futureGuidesList.length > 0) {
        let updatedItems = this.futureGuidesList.map((e) => ({
          ...e.purchItmDwn,
        }));
        for (let item of updatedItems) {
          try {
            let updated = await this.apiService.updatePurchItmDwn(item);
          } catch (error) {
            console.error("error en uploadPurchITems:", error);
            console.error("error en:", item);
          }
        }
      }
    } else {
      this.messageService.add({
        severity: "error",
        summary: `${this.translations.lbl_list} ${this.translations.lbl_empty}`,
        detail: `${this.translations.lbl_there_is_not} ${this.translations.lbl_information} ${this.translations.lbl_to} ${this.translations.lbl_update}`,
        life: 3000,
      });
      this.blocked = true;
    }
  }

  async approveItems() {
    const docId = this.docId || null;
    const seq = this.sequence || null;
    const type = "A";
    try {
      let response = await this.apiService.checkGrantAudioPlay({
        docId: docId,
        sequence: seq,
        type: type,
      });

      if(response.status == 'ERROR'){
        this.messageService.add({
          severity: "error",
          summary: `${this.translations.lbl_error} ${this.translations.lbl_approve}`,
          detail: response.errorMessage,
          life: 3000,
        });
      }else{
        window.close();
      }
    } catch (error) {
      console.error("error en aprovar items:", error);
      this.blocked = false;
    }
  }
}
